import { Container, Row, Col } from "react-bootstrap";
import "../../../assets/css/customer/screens/home/Testimonials.css";

const testimonials = [
  {
    id: 1,
    quote:
      "After 6 sessions my skin is smoother than ever. The team made me feel completely safe.",
    name: "Aisha R.",
    role: "Laser hair removal patient",
  },
  {
    id: 2,
    quote:
      "My acne finally cleared up after years of trying everything. Estatica's plan actually worked.",
    name: "Hira K.",
    role: "Acne treatment patient",
  },
  {
    id: 3,
    quote:
      "I get a Hydrafacial every month — it's the only thing that keeps my skin glowing through busy weeks.",
    name: "Mariam S.",
    role: "Hydrafacial regular",
  },
];

const QuoteIcon = () => (
  <svg
    className="ac-testi__quote-icon"
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#e27a8b"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z" />
    <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z" />
  </svg>
);

const EstaticeTestimonials = () => {
  return (
    <section className="ac-testi">
      <Container className="ac-testi__container">

        {/* Header */}
        <div className="ac-testi__header">
          <h2 className="ac-testi__heading">Patient stories</h2>
        </div>

        {/* Cards */}
        <Row className="ac-testi__row">
          {testimonials.map((t) => (
            <Col lg={4} md={4} sm={12} key={t.id} className="ac-testi__col">
              <div className="ac-testi__card">
                <QuoteIcon />
                <p className="ac-testi__quote">"{t.quote}"</p>
                <div className="ac-testi__author">
                  <span className="ac-testi__author-name">{t.name}</span>
                  <span className="ac-testi__author-role">{t.role}</span>
                </div>
              </div>
            </Col>
          ))}
        </Row>

      </Container>
    </section>
  );
};

export default EstaticeTestimonials;